import React, { ReactElement } from "react"
import { Tabs, Tab } from "@wfp/ui"
import { settingsTabs } from "constants/household"
import Settings from "components/Household/Settings/Settings"

const SettingsPage = (): ReactElement => {
  return (
    <div>
      <Tabs disableAnimation>
        {settingsTabs.map(tab => (
          <Tab
            key={tab.tabIndex}
            label={tab.label}
            href={tab.href}
            role={tab.role}
            selected={tab.selected}
            tabIndex={tab.tabIndex}
          >
            <Settings type={tab.type} withFilter={tab.withFilter} />
          </Tab>
        ))}
      </Tabs>
    </div>
  )
}

export default SettingsPage
